/**
 * User access control related enums moved to @jerry-serverless/authlib
 */

/**
 * User Stage for Insurance
 */
export enum UserStage {
  New = 1,
  QuotingEZLynx = 3,
  QuoteSent = 4,
  SwitchRequoting = 8,
  SwitchIntent = 9,
  SwitchPriceProvided = 10,
  SwitchBinding = 11,
  WaitingRequote = 12,
}

/**
 * Labels for user stage
 */
export const userStageLabels = {
  [UserStage.New]: 'New',
  [UserStage.QuotingEZLynx]: 'Quoting EZLynx',
  [UserStage.QuoteSent]: 'Quote Sent',
  [UserStage.SwitchRequoting]: 'Switch - Requoting',
  [UserStage.SwitchIntent]: 'Switch – Intent',
  [UserStage.SwitchPriceProvided]: 'Switch – Final Price Provided',
  [UserStage.SwitchBinding]: 'Switch – Binding',
  [UserStage.WaitingRequote]: 'Waiting for Requote',
};

/**
 * The length of auto insurance if the auto is currently insured, or null if the auto is not insured
 */
export enum AutoInsuredLengthType {
  LessThanSixMonths = 'LessThanSixMonths',
  MoreThanSixMonths = 'MoreThanSixMonths',
  SixToTwelveMonths = 'SixToTwelveMonths',
  OneToThreeYears = 'OneToThreeYears',
  ThreeToFiveYears = 'ThreeToFiveYears',
  MoreThanFiveYears = 'MoreThanFiveYears',
}

/**
 * Pre defined user delete reasons
 */
export enum UserDeleteReason {
  FakeCustomer = 'fake',
  CustomerRequestedToBeDeleted = 'customer_requested',
  UnableToGetCustomerInfo = 'cant_get_info',
  CustomerNotInServiceArea = 'out_of_service_area',
  DeletedByCMSAdmin = 'deleted_by_cms_admin',
  DeletedFromWebSignupChallenge = 'deleted_from_web_signup_challenge',
  DeletedFromWebPartnerPrefill = 'deleted_from_web_partner_prefill',
  DeletedFromRetrieveAccountFlow = 'deleted_from_retrieve_account_flow',
}
// make sure this enum is consistent with the one in apps/signup/types/homeownership.enum.ts
export enum HomeOwnership {
  Owned = 'Home(owned)',
  Rental = 'Rental home/condo',
  Apartment = 'Apartment',
  Other = 'Other',

  MobileHome = 'Mobile home',
  LiveWithOthers = 'Live with family/friends',
  LiveWithOthers2 = 'Live with family or friends',
  Rent = 'Rent an apartment/home/mobile home',
  // https://app.asana.com/0/1200876481063191/1203275241369049
  DoesNotHoldTitle = 'Does not hold title',
}

export enum RelationshipToApplicantEnum {
  Insured = 'Insured',
  Spouse = 'Spouse',
  DomesticPartner = 'Domestic Partner',
  Child = 'Child',
  Other = 'Other',
  Parent = 'Parent',
  Relative = 'Relative',
}

/**
 * Driver relation types
 */
export enum RelationToUser {
  Child = 'Child',
  DomesticPartner = 'DomesticPartner',
  Employee = 'Employee',
  Insured = 'Insured',
  Other = 'Other',
  Parent = 'Parent',
  Relative = 'Relative',
  Spouse = 'Spouse',
  Friend = 'Friend',
}

export enum IncomeFrequencyType {
  Annually = 'Annually',
  Biweekly = 'Biweekly',
  Hourly = 'Hourly',
  Monthly = 'Monthly',
}

/**
 * Describes the years the user has lived at their address
 */
export enum UserYearsAtAddress {
  // Less than 2 months
  LessThanTwoMonths = 0,
  // 2 to 12 months
  TwoMonthsToOneYear = 1,
  // More than 1 year
  MoreThanOneYear = 2,
  // 2 to 6 months
  TwoMonthsToSixMonths = 3,
  // 6 to 12 months
  SixMonthsToOneYear = 4,
}

export enum FaultAccidentType {
  Yes = 'Yes',
  No = 'No',
  DoNotRemember = 'DoNotRemember',
}

export enum ViolationsCountType {
  None = 'None',
  OneToTwo = 'OneToTwo',
  ThreeToFour = 'ThreeToFour',
  FiveOrMore = 'FiveOrMore',
  DoNotRemember = 'DoNotRemember',
}

export enum AdditionalInfoAffinityGroups {
  NONE = 'None',
  BANK = 'A member of a bank, credit union, credit card company, or military financial. ',
  EMPLOYED = 'Employed by or retired from a financial institution, K-12 school, community college, or college/university.',
}
